import React, {useState, useEffect} from 'react';
import {Link} from 'react-router-dom';
import {Button} from 'react-bootstrap';
import swal from "sweetalert";
import MainPagetitle from '../../layouts/MainPagetitle';
import CamperVideoService from '../../api/services/CamperVideoService';

const CamperVideo = () => {  
    const [tutorial, setTutorial] = useState([]);
    useEffect(() => {
        getCamperVideo();
    }, []);
    const getCamperVideo = async () => {
        try {
          let tutorial = await CamperVideoService.index().json();
          setTutorial(tutorial.data);
        } catch (error) {
          console.log(error);
        }
      };
      const deleteCamperVideo = async(id) => {
        let responseData = await CamperVideoService.destroy(id).json()
          swal({
            title: "Are you sure?",
            text:"Once deleted, you will not be able to recover this data!",
            icon: "warning",
            buttons: true,
            dangerMode: true,
            }).then((willDelete) => {
            if (willDelete) {
                if (responseData.status === 200) {
                    getCamperVideo();
                } 
                swal("Your Camper Video has been deleted successfully!", {
                  icon: "success",
                });
            } 
            }).catch(() => {
                swal("Your Camper Video is safe!");
            });
      }
    return (
        <>
            <MainPagetitle mainTitle="Camper Video" pageTitle={'Camper Video'} parentTitle={'Home'} />  
            <div className="container-fluid">
				        <div className="row">
			    	        <div className="col-xl-12">
                        <div className="card">            
                            <div className="card-body p-0">
                                <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting">   
                                    <div className="tbl-caption d-flex justify-content-between text-wrap align-items-center">
                                        <h4 className="heading mb-0">Camper Video</h4>                                        
                                        <div>
                                            <Link to={`/admin/add_videos/`} className="btn btn-primary btn-sm ms-1">+ Add Explanatory Video</Link> {" "}
                                        </div>
                                    </div>          
                                    <div id="employee-tbl_wrapper" className="dataTables_wrapper no-footer">
                                        <table id="empoloyees-tblwrapper" className="table ItemsCheckboxSec dataTable no-footer mb-0">
                                            <thead>
                                                <tr>   
                                                    <th>Camper Title</th>
                                                    <th>Video Category</th>
                                                    <th className="d-flex">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {tutorial.map((item, index)=>(
                                                    <tr key={index}>   
                                                        <td>
                                                            <div className="products">
                                                                <h6>{item.camper}</h6>
                                                            </div>
                                                        </td>
                                                        <td>
                                                        <div className="">
                                                                <h6>{item.videoType}</h6>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="d-flex">
                                                                <Link
                                                                to={`/admin/edit_videos/${item.id}`}
                                                                className="btn btn-primary shadow btn-xs sharp me-1"
                                                                >
                                                                <i className="fas fa-pencil-alt"></i>
                                                                </Link>
                                                                <Button className="btn btn-danger shadow btn-xs sharp" onClick={() => {deleteCamperVideo(item.id)}} 
                                                                >
                                                                <i className="fa fa-trash"></i>
                                                                </Button>
                                                            </div>
                                                        </td>
                                                       
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
           
        </>
    );
};

export default CamperVideo;